// NPM Imports
import React from "react";
import { useDispatch, useSelector } from "react-redux";

// Components Imports
import { ConfirmationBox } from "../../../commonComponents";

import { tableAPILinkUnlink } from "../../../actions/TableFieldActions/index";

// Internal imports

function TableAPIUnlinkPopup({
  fieldsUsed,
  section,
  updateMultipleState,
  showTableAPIUnlinkPopup,
}) {
  const docId = useSelector(state => state.DocumentStore.document.id);
  const dispatch = useDispatch();

  const _closePopup = () => {
    updateMultipleState({
      showTabletoQuoteUnlink: false,
    });
  };

  const _handleConfirmation = () => {
    const { clauseOptions } = section;
    if (clauseOptions && clauseOptions.id) {
      const clauseField = fieldsUsed.find(
        field => field.id === clauseOptions.id,
      );
      if (clauseField.type === "TABLE_API") {
        dispatch(tableAPILinkUnlink(docId, clauseField.id, "unlink"))
          .then(() => {})
          .catch(err => {
            console.error("TableAPIUnlinkPopup => _handleConfirmation", err);
          });
      }
    }
  };

  return (
    <ConfirmationBox
      show={showTableAPIUnlinkPopup}
      closePopup={_closePopup}
      header="Heads up!"
      subHeader={` Unlinking this table might cause some issues in downstream actions.
            Incase you want to restore the data, click on the restore button in
            the dropdown.`}
      checkboxLabel="Yes, I want to unlink table"
      cancelBtnText="Cancel"
      disableCheckbox
      confirmAction={_handleConfirmation}
      okBtnText="Unlink table"
      closeOnOverlayClick={false}
    />
  );
}

export default TableAPIUnlinkPopup;
